import type {ReactElement, SyntheticEvent} from 'react';
import React from 'react';
import type {ImageProps} from 'react-bootstrap';
import {Image} from 'react-bootstrap';
import {SkeletonBrick, SkeletonBrickTheme} from "@Components/skeleton-brick";
import styles from './chat-image.module.scss';

export function ChatImage({...props}: ImageProps): ReactElement {
	const [loaded, setLoaded] = React.useState(false);
	const handleImageLoad = (e: SyntheticEvent<HTMLImageElement>): void => {
		props.onLoad?.(e)
		setLoaded(true);
	};

	return (
		<div className={styles.imageContainer}>
			<SkeletonBrick
				width={400}
				height={400}
				theme={SkeletonBrickTheme.AI_GRADIENT}
				className={`${props.className} ${styles.skeleton} ${loaded ? styles.hidden : styles.visible}`}
			/>
			<Image
				{...props}
				onLoad={handleImageLoad}
				className={`${props.className} ${styles.image} ${loaded ? styles.visible : styles.hidden}`}
			/>
		</div>
	);
}